import styled from "styled-components"
import InputText from "../shared/input/new/InputText"
import { useEffect, useState } from "react"
import InputTextarea from "../shared/input/new/InputTextarea"
import InputSelect from "../shared/input/new/InputSelect"
import Btn from "../shared/button/Btn"
import { useDispatch } from "react-redux"
import SmallSpinner from "../shared/spinners/SmallSpinner"
import { useSelector } from "react-redux"
import { MdOutlineCheck } from "react-icons/md";
import { mainMenuOptions } from "../../utils/portalBildirimOptions"
import PortalBildirimMainMenuInput from "../shared/input/special/PortalBildirimMainMenuInput"
import PortalBildirimSubMenuInput from "../shared/input/special/PortalBildirimSubMenuInput"
import { sendPortalNotificationAll, setNotificationMenuPortal, setNotificationSubMenuPortal, setNotificationTextPortal, setNotificationTitlePortal } from "../../features/admin4/admin4Slice"


import RegularWeekSelectPortalContainer from "./RegularWeekSelectPortalContainer"
import TargetDateNotificationPortalContainer from "./TargetDateNotificationPortalContainer"
import RegularMonthSelectPortalContainer from "./RegularMonthSelectPortalContainer"
import { sendOptions } from "../../utils/bildirimOptions"

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 0 40px;

    .process-seperator{
        width: 100%;
        background-color: ${({theme}) => theme.mainBorderColor};
        height: 1px;
    }

    .extra-content-container{
        display: flex;
        margin: 20px 0;
        gap: ${({selectedSendType}) => selectedSendType ? "50px" : 0} ;

        .select-side{

        }

        .select-result-side{
            display: flex;
            flex-direction: column;

    
        }
    }
`
const SendNotificationAllPortalUsers = () => {

    const dispatch = useDispatch()

    const {
        isLoadingSendPortalNotificationAll,
    
        notificationTitlePortal,
        notificationTextPortal,
    
        notificationMenuPortal,
    
        notificationSubMenuPortal
    
    } = useSelector(state => state.admin4)

    const [selectedSendType, setSelectedSendType] = useState({
        id:null,
        text: ""
    })

    const handleClickNow = () => {

        if(notificationTitlePortal && notificationTextPortal && notificationMenuPortal?.value){
            dispatch(sendPortalNotificationAll({
                text: notificationTextPortal,
                title: notificationTitlePortal,
                route: notificationMenuPortal.value,
                altRoute: notificationSubMenuPortal.value,


            }))
        }
  
    }
 
  return (
    <Container selectedSendType={selectedSendType.id !== null}>
        <InputText data={notificationTitlePortal} setData={(e) => dispatch(setNotificationTitlePortal(e.target.value))} labelText="Bildirim Başlığı" inputWidth={"350px"} name={"title"}/>
        <InputTextarea data={notificationTextPortal} setData={(e) => dispatch(setNotificationTextPortal(e.target.value))} labelText={"Bildirim Metni"}  inputWidth={"350px"} name={"content"}/>
        <PortalBildirimMainMenuInput data={notificationMenuPortal?.text} setData={(data) => dispatch(setNotificationMenuPortal({item:data, pastNotificationMenuPortal:notificationMenuPortal}))} initialOptions={mainMenuOptions} labelText={"Menü"} inputWidth={"350px"} name={"menu"}/>
        <PortalBildirimSubMenuInput data={notificationSubMenuPortal?.text} setData={(data) => dispatch(setNotificationSubMenuPortal(data))} initialOptions={notificationMenuPortal?.subMenus || []} labelText={"Alt Menü"} inputWidth={"350px"} name={"subMenu"}/>
        <div className="process-seperator"/>
        <div className="extra-content-container">
            <div className="select-side">
                <InputSelect data={selectedSendType?.text} setData={(item) => setSelectedSendType(item)} initialOptions={sendOptions} labelText={"Gönderim Tipi Seçiniz"} inputWidth={"350px"} name={"sendOptions"}/>
            </div>
            <div className="select-result-side">

                {
                    selectedSendType.id === 0 &&
                    <RegularMonthSelectPortalContainer isAll={true}/>
                }

                {
                    selectedSendType.id === 1 &&
                    <RegularWeekSelectPortalContainer isAll={true}/>
                }

                {
                    selectedSendType.id === 2 &&
                    <TargetDateNotificationPortalContainer isAll={true}/>
                }

                {
                    selectedSendType.id === 3 &&
                    <Btn handleClick={handleClickNow} bgColor="#E85546" color="#fff" width={"350px"}>{isLoadingSendPortalNotificationAll ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Gönder"}</Btn>
                }
            </div>
        </div>
    </Container>
  )
}

export default SendNotificationAllPortalUsers